import { CognitoUser } from '@aws-amplify/auth';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Auth } from 'aws-amplify';

// This type describes the error object structure:
type LoginError = {
  message: string;
};

type LoginPayload = {
  // loggingService: Logger;
  email: string;
  password: string;
};

export const loginThunk = createAsyncThunk<
  CognitoUser,
  LoginPayload,
  { rejectValue: LoginError }
>(
  'auth/loginThunk',
  async (
    payload,
    thunkApi,
    // TODO: figure out return type of rejectWithValue something like RejectWithValue<Alert>
  ) => {
    const { email, password } = payload;
    try {
      return await Auth.signIn(email, password);
    } catch (error: any) {
      return thunkApi.rejectWithValue({
        message: error?.message,
      });
    }
  },
);
